import React from 'react';
import { ClientData } from '../types/ClientData';
import ProgrammeMap from '../components/ProgrammeMap';

interface SessionThreeIntroProps {
  clientData: ClientData;
  onBegin: () => void;
}

function fmt(n: number | undefined): string {
  return n && n > 0 ? `£${n.toLocaleString()}` : '—';
}

export default function SessionThreeIntro({ clientData, onBegin }: SessionThreeIntroProps) {
  const activeScenarios = [
    clientData.s3ScenarioEarlierOn && 'Earlier Retirement',
    clientData.s3ScenarioPhasedOn && 'Phased Retirement',
    clientData.s3ScenarioStressOn && 'Stress Test',
    clientData.s3ScenarioLongevityOn && 'Longevity',
    clientData.s3ScenarioLifestyleOn && 'Lifestyle Business',
  ].filter(Boolean) as string[];

  const metrics = [
    { label: 'Freedom Number', value: fmt(clientData.freedomNumberInflated) },
    { label: 'Monthly committed', value: fmt((clientData.pensionCompanyFunded || 0) + (clientData.planIsaMonthlyContribution || clientData.isaContribution || 0)) },
    { label: 'Employer pension', value: clientData.pensionCompanyFunded ? `£${clientData.pensionCompanyFunded.toLocaleString()}/mo` : '—' },
    { label: 'Gap closed', value: clientData.totalGapClosed && clientData.gapAmount ? `${Math.round((clientData.totalGapClosed / clientData.gapAmount) * 100)}%` : '—' },
  ];

  return (
    <div className="max-w-4xl mx-auto p-8">
      <span style={{
        background: '#64DAD2',
        color: '#001F8C',
        fontSize: '11px',
        fontWeight: 700,
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
        padding: '4px 12px',
        borderRadius: '20px',
        display: 'inline-block',
        marginBottom: '16px',
      }}>
        Session 3 of 3
      </span>
      <h1 style={{ fontSize: '32px', fontWeight: 700, color: '#001F8C', marginBottom: '8px' }}>
        Life Design
      </h1>
      <p style={{ fontSize: '20px', fontStyle: 'italic', color: '#6b7280', marginBottom: '32px' }}>
        "Everything we've built. Now let's decide what to do with it."
      </p>

      <p style={{ fontSize: '12px', fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '16px' }}>
        What we've built together
      </p>

      <div style={{ display: 'flex', gap: '12px', marginBottom: '32px', flexWrap: 'wrap' }}>
        {metrics.map((m, i) => (
          <div key={i} style={{
            flex: '1 1 160px',
            background: 'white',
            border: '1px solid #e5e7eb',
            borderRadius: '12px',
            padding: '16px',
          }}>
            <p style={{ fontSize: '12px', color: '#6b7280', marginBottom: '6px' }}>{m.label}</p>
            <p style={{ fontSize: '20px', fontWeight: 700, color: '#001F8C' }}>{m.value}</p>
          </div>
        ))}
      </div>

      {activeScenarios.length > 0 && (
        <>
          <p style={{ fontSize: '12px', fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '12px' }}>
            Today's scenarios
          </p>
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '24px' }}>
            {activeScenarios.map(s => (
              <span key={s} style={{
                background: 'rgba(100,218,210,0.15)',
                color: '#001F8C',
                border: '1px solid #64DAD2',
                borderRadius: '20px',
                padding: '4px 14px',
                fontSize: '13px',
                fontWeight: 500,
              }}>
                {s}
              </span>
            ))}
          </div>
        </>
      )}

      <p style={{ fontSize: '15px', color: '#374151', marginBottom: '24px' }}>
        Today we explore what's possible, stress-test the plan, and design the life it funds.
        This session ends with a confirmed freedom age from Voyant.
      </p>

      {/* Programme Map — Brief 26 Section 4c */}
      <div style={{ marginTop: 32, marginBottom: 32 }}>
        <ProgrammeMap currentSession={3} completedSessions={[1, 2]} clientName={clientData.clientName} />
      </div>

      <button
        onClick={onBegin}
        style={{
          background: '#64DAD2',
          color: '#001F8C',
          border: 'none',
          borderRadius: '8px',
          padding: '14px 32px',
          fontSize: '16px',
          fontWeight: 600,
          cursor: 'pointer',
          fontFamily: 'inherit',
        }}
      >
        Begin Session →
      </button>
    </div>
  );
}
